export default "__VITE_ASSET__IVrxnLdp__"